import { SearchInput } from "../../../components/SearchInput";
import Filters from "./Filters";
import typography from "../typography";
import plusIcon from "../../../assets/images/app/common/plus-icon.svg";
import { STATE_KEY_OPTIONS, VIDEO_STATE_KEYS } from "../data";

export default function Header({
    contentTypeFilterVal = "ALL",
    stateKeyFilterVal = "ALL",
    statusFilterVal = "ACTIVE",
    filterUpdateHandler = () => {},
    searchTextVal = "",
    searchValUpdateHandler = () => {},
    onAddContent = () => {},
    onManageLockedSessions = () => {},
}) {
    const contentTypeFilterConfig = [
        { id: "ALL", title: typography.ALL },
        { id: "AUDIO", title: typography.AUDIO },
        { id: "VIDEO", title: typography.VIDEO },
    ];

    // Active is the ordinary listing; Bin surfaces soft-deleted content —
    // where the restore / permanently-delete actions live (see Listing.js).
    const statusFilterConfig = [
        { id: "ACTIVE", title: typography.STATUS_ACTIVE },
        { id: "BIN", title: typography.STATUS_BIN },
    ];

    // Lets admin see, per state, what's already uploaded — same tab pattern
    // as the content-type filter, one state at a time (mirrors how a student
    // only ever sees one state's activities at a time in the chooser).
    const stateKeyFilterConfig = [
        { id: "ALL", title: typography.ALL },
        ...STATE_KEY_OPTIONS.map((option) => ({ id: option.value, title: option.label })),
    ];

    // "Upload Video" once a video-only tab (Clarity/Energy/Comfort) is
    // selected — same action as "Add Content" elsewhere, just named for what
    // it actually is on the 3 states that only ever show video.
    const addButtonLabel = VIDEO_STATE_KEYS.includes(stateKeyFilterVal)
        ? typography.UPLOAD_VIDEO
        : typography.ADD_CONTENT;

    return (
        <div className="header-con-notification">
            <div className="filters-parent-con-notification">
                <div>
                    <Filters
                        activeTab={stateKeyFilterVal}
                        tabClickHandler={filterUpdateHandler}
                        config={stateKeyFilterConfig}
                        className="status-filter-con-notification"
                        label="State"
                        filterType="stateKey"
                    />
                </div>
                <div>
                    <Filters
                        activeTab={contentTypeFilterVal}
                        tabClickHandler={filterUpdateHandler}
                        config={contentTypeFilterConfig}
                        className="status-filter-con-notification"
                        label="Type"
                        filterType="contentType"
                    />
                </div>
                <div>
                    <Filters
                        activeTab={statusFilterVal}
                        tabClickHandler={filterUpdateHandler}
                        config={statusFilterConfig}
                        className="status-filter-con-notification"
                        label={typography.STATUS}
                        filterType="status"
                    />
                </div>
                <div className="search-input-notification-con">
                    <SearchInput
                        placeholder={typography.SEARCH}
                        type="text"
                        onChange={(e) => searchValUpdateHandler(e)}
                        value={searchTextVal}
                    />
                </div>
            </div>
            <div className="add-notification-con-notification">
                <button onClick={onManageLockedSessions} className="add-notification-btn">
                    <span>{typography.MANAGE_LOCKED_SESSIONS}</span>
                </button>
                <button onClick={onAddContent} className="add-notification-btn">
                    <img src={plusIcon} alt="plus icon" />
                    <span>{addButtonLabel}</span>
                </button>
            </div>
        </div>
    );
}
